<template>
  <div
    class="block-wrap block-specification"
    style="padding:10px">
    <div
      v-for="(s, sindex) in specifications"
      :key="sindex">
      <el-form class="title-bg" ref="skuForm" :model="s" :rules="skuRules" inline>
        规格名：
        <el-input v-if="s.isSale && s.required" :disabled="true" style="width:140px" v-model="s.name" :maxlength="20" @change="e => nameChange(s)"></el-input>
        <el-form-item v-else prop="name">
          <el-select
            v-model="s.name"
            width="140px"
            :loading="selectLoading"
            @change="changeSelectSpecName($event, s)"
            placeholder="请选择规格名"
          >
            <el-option
              v-for="op in selectSpecOptions"
              :key="op._optionKey"
              :value="op.parentSpecName"
              :label="op.parentSpecName"
              :disabled="specifications.some(_s => _s.name === op.parentSpecName && _s !== s)"
            />
          </el-select>
        </el-form-item>
        <el-checkbox
          style="margin-left: 8px"
          v-model="s.checked"
          @change="e => onChangeSpCheckbox(s)"
          :disabled="s.required"></el-checkbox>
          <el-button
            v-if="s.canNote"
            style="float: right; margin-right: 8px"
            type="link"
            @click="openBatchRemarkDialog(s.name)">批量设置规格备注</el-button>
          <el-button
          style="float: right"
          v-if="!s.required" type="link" @click="removeSpName(sindex)">删除</el-button>
        <span v-if="s.allowCreate" style="margin-left: 40px;font-size: 12px;"><i class="el-icon-warning" style="font-size: 16px; color: #E6A23C;"></i>该规格下规格值支持<span style="color: #E6A23C;">自定义</span></span>
      </el-form>
      <div class="specification-value">
        <div style="display: inline-block; padding-top: 7px; padding-left:10px;">规格值：</div>
        <vue-draggable class="specification-value-flex" v-model="specifications[sindex].values" handle=".drag-icon-wrap" :group="{ name: s.nameKey, pull: 'clone', put: false }" :animation="500">
          <div
            v-for="(v, vi) in specifications[sindex].values"
            :key="v.valueKey"
            class="specification-value-flex_item">
            <el-form ref="specFormRef" :key="vi" :model="v">
              <el-form-item prop="value" :rules="genFormItemValueRule(s, v, vi)">
                <div class="del-input-wrap">
                    <template v-if="s.valueUnit">
                      <el-input-digit
                        v-model.number="v.extendValues.specValue.value"
                        :precision="0"
                        style="width: 100px"
                        @change="val => extendValueChange(val, sindex, v, vi)"
                      />
                      <el-select
                        v-model="v.extendValues.specValue.valueUnit"
                        placeholder="请选择"
                        width="60px"
                        @change="val => extendValueUnitChange(val, sindex, v, vi)"
                        >
                        <el-option
                          v-for="unit in s.valueUnit"
                          :key="unit"
                          :label="unit"
                          :value="unit">
                        </el-option>
                      </el-select>
                    </template>
                    <el-select 
                      v-else-if="s.isSale"
                      :value="v.value"
                      @change="val => handleSelect(val, sindex, v, vi)"
                      placeholder="请输入或选择"
                      filterable
                      :allow-create="s.allowCreate"
                      :blur-create="s.allowCreate"
                      clearable
                      default-first-option
                    >
                      <template v-if="options[v.refPid].find(group => group.options && group.options.length)">
                        <el-option-group
                          v-for="group in options[v.refPid]"
                          :key="group.label"
                          :label="group.label">
                          <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                            :disabled="s.values.some(_v => _v.value === item.value)"
                            >
                          </el-option>
                        </el-option-group>
                      </template>
                      <template v-else>
                        <el-option
                          v-for="(op, opidx) in options[v.refPid]"
                          :key="`${sindex}-${vi}-${opidx}`"
                          :label="op.value"
                          :value="op.value"
                          :disabled="s.values.some(_v => _v.value === op.value)"
                        ></el-option>
                      </template>
                    </el-select>
                    <el-input
                      v-else
                      v-model="v.value"
                      placeholder="请输入"
                      class="specification-value-flex_input"
                      @keyup.enter.native="(e) => valueEnter(sindex, vi)"
                      @input="(e) => valueInput(e, s, v)"
                      ></el-input>
                    <el-checkbox style="margin-left: 8px;vertical-align: middle;"
                      v-model="v.checked"
                      @change="e => onChangeCheckbox(v)"
                      :disabled="v.checked && specifications[sindex].values.filter(item => item.checked).length === 1">
                    </el-checkbox>
                    <div @click="removeSpValue(sindex, vi, v)" class="del-btn"><i class="el-icon-close" /></div>
                  <drag-item-content></drag-item-content>
                </div>
              </el-form-item>
              <el-form-item prop="note" v-if="s.canNote" :rules="genFormItemRemarkRule(v)">
                <div class="remarkWrap">
                  <el-input
                    class="input-remark"
                    :ref="`${sindex}-${vi}-remark`"
                    placeholder="规格备注"
                    @change="e => remarkInput(v)"
                    v-model="v.note"></el-input>
                </div>
              </el-form-item>
              <el-form-item :error="vi[`imgUrlError`]" v-if="s.showImg" prop="imageUrl" :rules="genFormItemImgRule(v, s, `${sindex}-${vi}-img`)">
                <div class="specification-value-flex_img">
                  <ImgUpload
                    :ref="`${sindex}-${vi}-img`"
                    :width="80"
                    :height="80"
                    :file="v.imageUrl"
                    v-bind="imgLimits"
                    @handleLoad="handleImgLoad(v, `${sindex}-${vi}-img`)"
                    @upload-success="(url) => imageUploadSuccess(url, v, vi)"
                    @del="() => imageUploadDel(v)"
                    :isSingle="true"
                    :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="specification-value-flex_item drag-ignore_item">
            <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
          </div>
        </vue-draggable>
      </div>
      <div class="tips ft-12 ml-70" v-if="sindex === 0" style="color:#ccc;">
        <span>默认取商品第一张主图，买家选择不同规格会看到对应规格图片，长宽比仅支持 1:1 且长宽尺寸需大于 480px，建议尺寸: 800 x 800 像索，建议格式:png，jpg，jpeg格式</span>
      </div>
    </div>
    <div v-if="showAddSpNameBtn" class="title-bg">
      <el-button @click="handleAddSpName">添加商品规格</el-button>
    </div>
    <BatchSetSpecRemarksDialog ref="batchSetSpecRemarksDialogRef"/>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload'
import BatchSetSpecRemarksDialog from '@/components/prod/center/components/BaseInfoForm/components/BatchSetSpecRemarksDialog.vue'
import { dragItemMixin } from '../../../utils/mixins'
import genkey from '@/utils/genkey.js'

import { cloneDeep } from 'lodash';

// const sizeTypeNames = ['尺码', '童鞋尺码', '参考分类', '鞋码']
export default {
  components: {
    ImgUpload,
    BatchSetSpecRemarksDialog,
  },
  model: {
    prop: 'values',
    event: 'change'
  },
  mixins: [dragItemMixin],
  props: {
    values: {
      type: Array,
      default() {
        return []
      }
    },
    changeToBase: { // 打开基础资料编辑
      type: Function,
      default: () => {}
    },
    imgLimits: {
      type: Object,
      default: () => {
        return {}
      }
    },
    remarkKey: {
      type: String,
      default: ''
    },
    sizeType: {// 规格类型
      type: Number,
      default: 1
    },
    specOptions: {
      type: Array,
      default() {
        return []
      }
    },
    sizeTypeNames: {
      type: Array,
      default() {
        return []
      }
    },
    updateSpecIds: {
      type: Function
    },
    canNoteItems: {
      type: Array,
      default() {
        return []
      }
    },
    customSpecNum: Number,
    validateSkuRowImage: {
        type: Function,
        default: null
    },
    carouselGallery:{
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      specifications: [],
      selectLoading: false, // 规格名下拉框loading
      // options: {},
      isDefault: true,
      requiredNoMatchSaleSpecs: [],
      imgErrorMsg:{},
    }
  },
  computed: {
    skuRules({ selectSpecOptions }) {
      return {
        name: [
          { validator: (_, value, callback) => {
            if (~selectSpecOptions.findIndex(s => s.parentSpecName === value)) {
              callback();
            } else {
              callback(new Error('规格名不存在，重新选择'))
            }
          }, trigger: 'change' }
        ],
      };
    },
    showAddSpNameBtn() {
      return this.customSpecNum > this.specifications.filter(s => !s.isSale).length
    },
    selectSpecOptions() {
      const addedNames = []
      const result = []
      // 非必填销售属性（来自 canNoteItems，优先级高）
      this.canNoteItems.forEach(item => {
        if (!item || item.required) return
        if (addedNames.includes(item.name)) return
        addedNames.push(item.name)
        result.push({
          parentSpecName: item.name,
          parentSpecId: item.parentSpecId,
          refPid: item.refPid,
          _source: 'sale',
          _optionKey: 'sale_' + item.refPid,
          canNote: item.canNote,
          allowCreate: item.inputMaxNum !== 0,
          valueUnit: (item.valueUnit || []).filter(Boolean),
          required: item.required,
        })
      })
      // 非销售属性（来自 specOptions，与销售属性重名的跳过）
      this.specOptions.forEach(opt => {
        if (addedNames.includes(opt.parentSpecName)) return
        result.push({
          parentSpecName: opt.parentSpecName,
          parentSpecId: opt.parentSpecId,
          _source: 'nonSale',
          _optionKey: 'nonSale_' + opt.parentSpecId,
        })
      })
      return result
    },
    options() {
      const res = {};
      this.canNoteItems.forEach((item, idx) => {
        if(!item) return 
        if (this.sizeTypeNames.includes(item.name)) {
          let hasGroup = false
          let values = item.values || [];
          if (values.length) {
            hasGroup = !!values[0].group
          }
          if (hasGroup) {
            values = (item.values || []).filter(v => String(v.group.id) === String(this.sizeType));
          } 
          res[item.refPid] = this.groupSpec((values || []).slice(0));
        } else {
          res[item.refPid] = this.groupSpec((item.values || []).slice(0));
        }
      })
      return res;
    }
  },
  watch: {
    values:{
      handler(v) {
        if(!v?.length) return
        this.specifications = v;
      },
      immediate: true,
      deep: true
    },
  },
  methods: {
    openBatchRemarkDialog(name) {
      this.$refs.batchSetSpecRemarksDialogRef.method_open({
        name,
        remarkKey: this.remarkKey || 'note',
        specifications: this.specifications,
        sureFn: (specs) => {
          this.$emit('change', JSON.parse(JSON.stringify(specs)));
        },
      });
    },
    async handleImgLoad(v, ref) {
      let errMsg = await this.$refs[ref][0].method_validImage()
      v.imgUrlError = errMsg
      const errArr = []
      errArr.push(errMsg)
      this.validateSkuRowImage(errArr)
    },
    // 颜色信息分组
    groupSpec(values) {
      const groups = values.reduce((acc, v) => {
        if (v.group) {
          if (!acc[v.group.name]) acc[v.group.name] = [];
          acc[v.group.name].push(v);
        } else {
          if (!acc['其他']) acc['其他'] = [];
          acc['其他'].push(v);
        }
        return acc;
      }, {});
      const options = [];
      for (let key in groups) {
        options.push({
          label: key,
          options: groups[key]
        })
      }
      if(options.length === 1 && options[0].label === '其他') {
        options[0].label = ''
      }
      return options;
    },
    validateSpecForm() {
      const valueForms = this.$refs.specFormRef;
      const skuForms = this.$refs.skuForm || [];
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.concat(Array.isArray(skuForms) ? skuForms : [skuForms]).map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            })
          })
        });
        Promise.all(promiseList).then((results) => {
          const allValid = results.every(result => result);
          if(!allValid) {
            resolve(allValid);
          }
          resolve(true);
        }).catch(() => {
          console.log('validateSpecForm has Error')
          resolve(false);
        })
      })
    },
    genFormItemValueRule(specItem, v, vi) {
      let valueValidator = (rule, value, callback) => {
        let options = this.options[v.refPid] 
        if(!specItem.allowCreate && specItem.isSale &&  value && options?.length) {
          const findItem = this.getItemByOptins(value,v.refPid)
          if(!findItem) {
            return callback(new Error('规格值匹配失败，请重新选择'))
          }
        }
        if(value) {
          const findItem = specItem.values.find((item, i) => item.value === value && i !== vi)
          if(findItem) {
            return callback(new Error('请勿输入相同规格值'))
          }
        }
        callback();
      }
      return [
        { required: true, message: '规格值必填' },
        { validator: valueValidator }
      ];
    },
    genFormItemRemarkRule(v) {
      // 规格值 + 备注长度校验
      let valueValidator = (rule, value, callback) => {
        const totallen = ((v.value || '') + (v.note || '')).length;
        if (totallen > 40) {
          return callback(new Error('规格值+备注不超过40个字'))
        }
        callback();
      }
      return [ { validator: valueValidator }];
    },
    genFormItemImgRule(valueItem, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        const refImg = this.$refs[ref]
        if (valueItem.imageUrl && refImg && refImg[0]) {
          let errMsg = await refImg[0].method_validImage()
          const errArr = []
          errArr.push(errMsg)
          this.validateSkuRowImage(errArr)
          if(errMsg) {
            return callback(new Error(errMsg))
          } else {
            callback();
          }
        }
        callback();
      }
      return [
        {
          required: true,
          validator: valueValidator
        }
      ];
    },
    onChangeCheckbox(v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationCheckbox_changed = true;
    },
    remarkInput(v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationCheckbox_changed = true;
    },
    nameChange(s) {
      this.$set(s, 'isEdited', true)
    },
    async changeSelectSpecName(val, s) {
      this.$set(s, 'isEdited', true)
      window.__spcificationCheckbox_changed = true
      const opt = this.selectSpecOptions.find(o => o.parentSpecName === val)
      if (!opt) return
      if (opt._source === 'sale') {
        await this._switchToSaleAttribute(s, opt)
      } else {
        this._switchToNonSaleAttribute(s, opt)
      }
      const specifications = await this.updateSpecificationsPropValueId(s)
      this.$emit("change", specifications)
    },
    // 切换到销售属性
    async _switchToSaleAttribute(s, opt) {
      const canNoteItem = this.canNoteItems.find(item => item.refPid === opt.refPid)
      if (!canNoteItem) return

      const existingValues = s.values || []
      const saleValues = canNoteItem.values || []

      // 构建销售属性选项的映射，便于快速查找 metadata
      const saleValueMap = {}
      saleValues.forEach(valItem => {
        saleValueMap[valItem.value] = valItem
      })

      // 遍历已有规格值，逐个尝试匹配销售属性选项
      const matchedValues = existingValues.map(v => {
        const saleMatch = saleValueMap[v.value]
        if (saleMatch) {
          // 匹配到销售属性选项，补充 metadata
          return {
            ...v,
            specId: saleMatch.specId || '',
            vid: saleMatch.vid || '',
            groupId: (saleMatch.group && saleMatch.group.id) || '',
            refPid: opt.refPid,
            parentSpecId: canNoteItem.parentSpecId || opt.parentSpecId,
            propId: canNoteItem.parentSpecId || opt.parentSpecId,
            propValueId: saleMatch.specId || '',
            value: saleMatch.value,
            valueKey: v.valueKey,
          }
        }
        // 未匹配到销售属性选项，保留值但清除销售属性特有 metadata
        return {
          ...v,
          refPid: opt.refPid,
          parentSpecId: canNoteItem.parentSpecId || opt.parentSpecId,
          propId: canNoteItem.parentSpecId || opt.parentSpecId,
          value: v.value,
          valueKey: v.valueKey,
          specId: '',
          vid: '',
          groupId: '',
          propValueId: '',
        }
      })

      s.isSale = true
      s.required = canNoteItem.required || false
      s.parentSpecId = canNoteItem.parentSpecId || opt.parentSpecId
      s.refPid = opt.refPid
      s.nameKey = s.nameKey || val
      s.allowCreate = canNoteItem.inputMaxNum !== 0
      s.canNote = canNoteItem.canNote
      s.valueUnit = (canNoteItem.valueUnit || []).filter(Boolean)
      if (s.valueUnit.length && canNoteItem.inputMaxNum) {
        matchedValues.forEach(v => {
          if (!v.extendValues?.specValue) {
            this.$set(v, 'extendValues', { ...v.extendValues, specValue: { value: '', valueUnit: '' } })
          }
        })
      } else {
        this.$delete(s, 'valueUnit')
      }
      s.values = matchedValues
    },
    // 切换到非销售属性
    _switchToNonSaleAttribute(s, opt) {
      const existingValues = s.values || []

      s.values = existingValues.map(v => ({
        checked: v.checked,
        value: v.value,
        valueKey: v.valueKey,
        note: v.note || '',
        imageUrl: v.imageUrl || '',
        extendValues: v.extendValues,
        specId: '',
        vid: '',
        groupId: '',
        refPid: '',
        parentSpecId: '',
        propId: '',
        propValueId: '',
      }))

      s.isSale = false
      s.parentSpecId = opt.parentSpecId
      s.nameKey = s.nameKey || opt.parentSpecName
      this.$delete(s, 'refPid')
      this.$delete(s, 'allowCreate')
      this.$delete(s, 'canNote')
      this.$delete(s, 'valueUnit')
      this.$delete(s, 'required')
    },
    onChangeSpCheckbox(s) {
      this.$set(s, 'isEdited', true)
      window.__spcificationSpCheckbox_changed = true;
      this.$emit("change", this.specifications)
    },
    // 添加规格名
    handleAddSpName() {
      const specifications = cloneDeep(this.specifications)
      const spec = {
        checked: true,
        parentSpecId: '',
        name: '',
        nameKey: '',
        isSale: false,
        values: []
      }
      specifications.push(spec)
      this.$emit("change", specifications)
    },
    // 移除规格名
    removeSpName(index) {
      this.specifications.splice(index, 1)
      this.specifications?.length && this.$set(this.specifications[0], 'isEdited', true)
      this.$emit("change", this.specifications)
    },
    // 添加规格值
    addSpValue(index) {
      this.$set(this.specifications[index], 'isEdited', true)
      const { values, valueUnit, refPid } = this.specifications[index];
      const voidValue = {
        ...values[0],
        checked: true,
        refPid,
        value: '',
        valueKey: genkey.get('v'),
        groupId: '',
        specId: '',
        vid: '',
        note: '',
        imageUrl: ''
      }
      if (valueUnit  && !voidValue.extendValues?.specValue) {
        voidValue.extendValues = voidValue.extendValues || {};
        voidValue.extendValues.specValue = { value: '', valueUnit: '' };
      }
      this.specifications[index].values.push(voidValue);
      window.__spcificationImg_changed = voidValue.valueKey // 用于skuList生成时的图片取值规则
      this.$emit("change", this.specifications)
    },
    // 移除规格值
    removeSpValue(sindex, index, v) {
      this.specifications[sindex].values.splice(index, 1);
      this.$set(this.specifications[sindex], 'isEdited', true)
      window.__spcificationImg_changed = v.valueKey;
      this.$emit("change", this.specifications)
    },
    querySearch(v, str, cb) {
      cb(this.options[v.refPid] || []);
    },
    getItemByOptins(val, refPid) {
      let item = null;
      let options = this.options[refPid] || [];
      if (options && options[0] && options[0].options) {
        options = options.reduce((acc, op) => {
          acc = acc.concat(op.options);
          return acc;
        }, []);
      } 
      const idx = options.findIndex(it => it.value === val);
      if (idx !== -1) {
        item = options[idx];
      }
      return item;
    },
    async handleSelect(val, sindex, v, vi) {
      this.$set(v, 'isEdited', true)
      let item = this.getItemByOptins(val, v.refPid);
      let value = {};
      if (!item) {
        value = {
          ...v,
          value: val,
          specId: '',
          vid: '',
          groupId: '',
          valueKey: v.valueKey
        }
      } else {
        v.value = val;
        if (this.isSame(this.specifications[sindex].values, item.value, vi)) {
          this.$message.error('请勿选择相同规格值');
          return;
        }
        value = {
          ...v,
          ...item,
          groupId: (item.group && item.group.id) || '',
          valueKey: v.valueKey,
        }
      }
      this.$set(this.specifications[sindex].values, vi, value)
      const specifications = await this.updateSpecificationsPropValueId(this.specifications[sindex], [val])
      this.$emit("change", specifications)
    },
    isSame(values, value, idx) {
      let flag = false;
      values.forEach((item, i) => {
        if (i !== idx && item.value === value) {
          flag = true;
        }
      });
      return flag;
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`]
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm
      if (nextInputVm) {
        // 聚焦到下一个
        nextInputVm.focus()
      }
    },
    async valueInput(val, s, v) {
      this.$set(v, 'isEdited', true)
      window.__spcificationImg_changed = true
      const specifications = await this.updateSpecificationsPropValueId(s, [val])
      this.$emit("change", specifications)
    },
    async updateSpecificationsPropValueId(s, specNames) {
      await this.updateSpecIds(s, specNames)
      const specifications = JSON.parse(JSON.stringify(this.specifications))
      return specifications.map(spec => {
        if(s.name === spec.name) {
          return s
        }
        return spec
      })
    },
    async imageUploadSuccess(url, v, vi) {
      this.$set(v, 'isEdited', true)
      v.imageUrl = url;
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
      // this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
    },
    imageUploadDel(v) {
      this.$set(v, 'isEdited', true)
      this.isDefault = false;
      v.imageUrl = '';
      window.__spcificationImg_changed = v.valueKey // 用于skuList生成时的图片取值规则
      // this.$emit("change", JSON.parse(JSON.stringify(this.specifications)))
    },
    async validate() {
      const specificationValid =  await this.validateSpecForm()
      if (!specificationValid) {
        return false;
      }
      return true;
    },
    hasValueUnit(v) {
      return v.extendValues?.specValue?.valueUnit;
    },
    async extendValueChange(val, sindex, v, vi) {
      this.$set(v, 'isEdited', true)
      const value = val + v.extendValues.specValue.valueUnit;
      this.specifications[sindex].values[vi].value = value;
      this.specifications[sindex].values[vi].extendValues.specValue.value = val;
      const specifications = await this.updateSpecificationsPropValueId(this.specifications[sindex], [value])
      this.$emit("change", specifications)
    },
    async extendValueUnitChange(valUnit, sindex, v, vi) {
      this.$set(v, 'isEdited', true)
      const value = v.extendValues.specValue.value + valUnit;
      this.specifications[sindex].values[vi].value = value;
      this.specifications[sindex].values[vi].extendValues.specValue.valueUnit = valUnit;
      const specifications = await this.updateSpecificationsPropValueId(this.specifications[sindex], [value])
      this.$emit("change", specifications)
    }
  }
}
</script>

<style lang="scss" scoped>
.specification-value-flex_input{
  margin-bottom: 10px;
}
.block-wrap {
  border: 1px solid #DCDFE6;
  
  .input-value {
    display: inline-block;
  }
  .add-sku-tips {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 2px;
    padding: 5px 10px;
    font-size: 12px;
    margin-top: 10px;
  }
  .tips-btn {
    cursor: pointer;
  }
}
.title-bg {
  background: #f8f8f8;
  padding: 7px 10px;
  // ::v-deep .el-input input {
  //   background: #F8F8F8 !important;
  // }
}

.specification-value {
  display: flex;
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    position: relative;
    margin-top: 10px;

    // top: -16px;
    &_item {
      margin-right: 10px;
      margin-bottom: 15px;
    }
    &_img {
      width: 100%;
      margin-top: 10px;
      position: relative;
    }
    .el-input, .el-select {
      width: 160px;
    }
  }
  ::v-deep .el-form-item__error {
    position: relative; 
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0,0,0,.3);
    justify-content: center;
    align-items: center;
  }
  .del-btn {
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
}
.remarkWrap {
  margin-top: 5px;
  
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}

</style>